import { defineComponent as _defineComponent } from 'vue'
import TravRating from '@shared/ui/TravRating.vue';
    import TravStars from '@shared/ui/TravStars.vue';
    import ButtonDesktop from '@ve/components/button/desktop/Button.vue';
    import { ISimilarHotel } from '../types/similarHotels';
    import hotelCategories from '../config/hotelCategories';
    import getDistanceInfo from '../lib/getDistanceInfo';
    import getColorNumber from '../lib/getColorNumber';

    interface ISimilarHotelCard {
        hotel: ISimilarHotel
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'SimilarHotel',
  props: {
    hotel: null
  },
  setup(__props: any) {

const props = __props as {
        hotel: ISimilarHotel
    };

    
    const mappedCategory = hotelCategories.find((category) => category.id === props.hotel.hotelCategoryId);
    const clickCardHandler = () => {
        window.location.href = `/hotel/${props.hotel.id}${window.location.hash}`;
    };

return { __sfc: true,props, mappedCategory, clickCardHandler, TravRating, TravStars, ButtonDesktop, getDistanceInfo, getColorNumber }
}

})